import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import axios from 'axios';
import logo from '../assets/logo-asistelo.png';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    verifyEmail();
  }, [token]);

  const verifyEmail = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/auth/verify-email/${token}`);
      setStatus('success');
      setMessage(response.data.message || 'Email verificado exitosamente');
      
      // Redirigir al login después de 3 segundos
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.detail || 'Error al verificar email');
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <Card className="max-w-md w-full p-8 text-center shadow-lg border border-slate-200">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img src={logo} alt="Asistelo" className="h-12 w-auto" />
        </div>

        {status === 'verifying' && (
          <>
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 bg-[#2537b0]/10 rounded-full flex items-center justify-center">
                <Loader2 className="w-10 h-10 text-[#2537b0] animate-spin" />
              </div>
            </div>
            <h1 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              Verificando tu Email...
            </h1>
            <p className="text-slate-600" style={{ fontFamily: 'Inter, sans-serif' }}>
              Por favor espera mientras verificamos tu dirección de correo electrónico.
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
                <CheckCircle2 className="w-10 h-10 text-green-600" />
              </div>
            </div>
            <h1 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              ¡Email Verificado!
            </h1>
            <p className="text-slate-600 mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
              {message}
            </p>
            <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
              <p className="text-sm text-green-800 font-medium">
                ✅ Serás redirigido al login en unos segundos...
              </p>
            </div>
            <Button
              onClick={() => navigate('/login')}
              className="w-full bg-green-600 hover:bg-green-700"
            >
              Ir al Login
            </Button>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center">
                <XCircle className="w-10 h-10 text-red-600" />
              </div>
            </div>
            <h1 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              Error de Verificación
            </h1>
            <p className="text-slate-600 mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
              {message}
            </p>
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6 text-left">
              <p className="text-sm font-semibold text-amber-900 mb-2">
                ⚠️ Posibles causas:
              </p>
              <ul className="text-sm text-amber-800 space-y-2">
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>El enlace ha expirado (válido por <strong>24 horas</strong>)</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>El enlace ya fue utilizado</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>El enlace es inválido</span>
                </li>
              </ul>
            </div>
            <div className="space-y-3">
              <Button
                onClick={() => navigate('/email-verification-pending')}
                className="w-full bg-[#2537b0] hover:bg-[#1c2a8a]"
              >
                Solicitar Nuevo Email
              </Button>
              <Button
                onClick={() => navigate('/login')}
                variant="outline"
                className="w-full"
              >
                Volver al Login
              </Button>
            </div>
          </>
        )}
      </Card>
    </div>
  );
};
